import { ImageSource } from 'js/types';

export type SearchMode = 'default' | 'streamlineStyle' | 'otherVisualStyle' | 'character';

interface SearchModeConfig {
  excludedTabs: ImageSource[];
  excludedBackendSources: string[];
  defaultSearchTerm?: string;
}

export const SEARCH_MODE_CONFIG: Record<SearchMode, SearchModeConfig> = {
  default: {
    excludedTabs: [],
    excludedBackendSources: []
  },
  streamlineStyle: {
    excludedTabs: ['noun-project'],
    excludedBackendSources: ['library'],
    defaultSearchTerm: 'people'
  },
  otherVisualStyle: {
    excludedTabs: ['streamline-graphics', 'noun-project'],
    excludedBackendSources: ['streamline']
  },
  character: {
    excludedTabs: ['streamline-graphics', 'noun-project'],
    excludedBackendSources: ['streamline']
  }
};
